// useMonthGridDays.js

import { useMemo } from 'react';

import { getCalendarDateKey } from 'views/calendar/shared/calendarUtils';

const isSameDay = (a, b) => (
  a.getFullYear() === b.getFullYear()
  && a.getMonth() === b.getMonth()
  && a.getDate() === b.getDate()
);

const useMonthGridDays = ({ baseDate, today }) => {
  return useMemo(() => {
    const year = baseDate.getFullYear();
    const month = baseDate.getMonth();
    const firstOfMonth = new Date(year, month, 1);
    const startOffset = firstOfMonth.getDay();
    const gridStart = new Date(year, month, 1 - startOffset);

    const days = [];
    for (let i = 0; i < 42; i += 1) {
      const date = new Date(
        gridStart.getFullYear(),
        gridStart.getMonth(),
        gridStart.getDate() + i
      );
      days.push({
        date,
        key: getCalendarDateKey(date),
        isToday: isSameDay(date, today),
        inMonth: date.getMonth() === month,
      });
    }

    return days;
  }, [baseDate, today]);
};

export default useMonthGridDays;
